
const TemplateThree = () => {
    return (
      <div className="slideshow">
        <figure>
          {/* Project Details Starts */}
          <figcaption>
            <h3>USER INTERFACE React.JS</h3>
            <div className="row open-sans-font">
              <div className="col-12 mb-2">
                <i class="fab fa-react"></i>
                <span className="ft-wt-600 uppercase"> Powerful, clean, creative and easy to use Web Agency React Template. It is highly suitable template for companies that offer UI/UX Design, Branding, SEO&SMM, Digital Marketing, IT services, Development Services, Portfolio and all other internet marketing and services related companies.</span>
              </div>
            </div>
            {/* End .row */}
          </figcaption>
          {/* Project Details Ends */}
  
          {/*  Main Project Content Starts */}
          <img src="img/projects/templates/3.jpg" alt="Portolio" />
          {/* Main Project Content Ends */}
        </figure>
      </div>
      //  End .slideshow
    );
  };
  
  export default TemplateThree;
  